<template>
    <div class="pt-24">
        <form @submit.prevent="login" class="w-128 bg-white mx-auto px-8 py-8 rounded-lg shadow-lg">
            <h1 class="font-sans text-center">
                Мозгобойня<br/>
                <small class="text-grey-darker">Личный кабинет</small>
            </h1>

            <div class="py-4">
                <label class="block font-medium font-sans pb-2">Email</label>
                <input type="text" v-model="form.email" class="w-full shadow border px-2 py-2"
                       :class="{'border-red': form.errors.has('email')}"
                >
                <span class="text-sm text-red" v-if="form.errors.has('email')"
                      v-text="form.errors.first('email')"></span>
            </div>
            <div class="py-4">
                <label class="block font-medium font-sans pb-2">Пароль</label>
                <input type="password" v-model="form.password" class="w-full shadow border px-2 py-2"
                       :class="{'border-red': form.errors.has('password')}"
                >
                <span class="text-sm text-red" v-if="form.errors.has('password')"
                      v-text="form.errors.first('password')"></span>
            </div>

            <div class="pt-4">
                <button class="outline-none bg-brand text-white rounded-lg hover-up w-full py-4">
                    Войти
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Form from 'form-backend-validation';
import base from '../../clients/auth';
import partners from '../../clients/partners';

export default {
  data() {
    return {
      form: new Form(['email', 'password'], { http: base }),
    };
  },

  methods: {
    ...mapActions(['setToken', 'setUser']),

    login() {
      this.form.post('/login')
        .then((data) => {
          this.setToken(data.access_token);
          partners.get('/me')
            .then(({ data }) => {
              this.setUser(data);
              this.$router.push('/');
            });
        });
    },

  },
};
</script>
